export const amplitudeEventBridgeForClickEvents = (e: Event) => {
  const actualTarget = e.target; // This is the REAL clicked element

  if (!actualTarget) {
    return;
  }
  if (actualTarget instanceof Element) {
    const text = getTextFromElement(actualTarget);
    const eventProperties = {
      element_id: actualTarget.id,
      element_tag: actualTarget.tagName,
      element_class: actualTarget.className,
      clicked_text: text,
      page_url: window.location.href,
      page_title: document.title,
    };

    if (window.amplitude) {
      window.amplitude.track(`click_jobrad_calculator`, eventProperties);
    } else {
      // TODO remove as soon as amplitude is properly configured
      globalThis.console.log("Amplitude event (not sent, amplitude not initialized):", {
        eventName: `click_jobrad_calculator`,
        eventProperties,
      });
    }
  }
};

// Try to get meaningful text from the element
const getTextFromElement = (element: Element): string | undefined => {
  // First try aria-label (often used for accessibility)
  const ariaLabel = element.getAttribute("aria-label");
  if (ariaLabel?.trim()) {
    return ariaLabel.trim();
  }

  // Then try title attribute
  const title = element.getAttribute("title");
  if (title?.trim()) {
    return title.trim();
  }

  // For input elements, try placeholder or value
  if (element instanceof HTMLInputElement) {
    return element.placeholder?.trim() || element.value?.trim();
  }

  // For buttons, try innerText first (excludes hidden text), then textContent
  if (element instanceof HTMLButtonElement) {
    const innerText = element.innerText?.trim();
    if (innerText) {
      return innerText;
    }
  }

  // For img elements, try alt text
  if (element instanceof HTMLImageElement) {
    return element.alt?.trim();
  }

  // Finally fall back to textContent, but limit length to avoid overly verbose text
  const textContent = element.textContent?.trim();
  if (textContent && textContent.length > 0) {
    // Limit to first 30 characters to avoid capturing entire sections
    return textContent.length > 30 ? textContent.substring(0, 30) + "..." : textContent;
  }

  return undefined;
};
